import MobileMenu from './MobileMenu';

export { type MobileMenuProps } from './MobileMenu';
export default MobileMenu;
